import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {color, spacing} from "@khanacademy/wonder-blocks-tokens";
import {LabelSmall} from "@khanacademy/wonder-blocks-typography";
import type {GuideIconReaction} from "@repo/guide-utils";

import {LoadingDots} from "../loading-dots.tsx";

interface Props {
    /* Children to render */
    children: React.ReactElement | null;
    /* The reaction associated with the message Icon. */
    reaction: GuideIconReaction | null;
    /* The message to be displayed */
    statusMessage?: string;
}

/**
 * A component to indicate important information about the guide response.
 *
 * If there is no status message, we simply return the children.
 *
 * If there is a status message, we compose it with the children, and possibly
 * an additional indicator if the reaction is "thinking."
 */
export const ResponseStatus = ({children, reaction, statusMessage}: Props) => {
    if (!statusMessage) {
        return children;
    }

    return (
        <View style={styles.responseStatus}>
            {children}
            <LabelSmall style={styles.message}>{statusMessage}</LabelSmall>
            {reaction === "thinking" && (
                <>
                    <Strut size={spacing.xxxSmall_4} />
                    <LoadingDots color={color.offBlack64} size="small" />
                </>
            )}
        </View>
    );
};

const styles = StyleSheet.create({
    responseStatus: {
        flexDirection: "row",
    },
    message: {
        color: color.offBlack64,
    },
});
